import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import CertificationReports from '../../../../shared/Cis/CertificationReports/CertificationReports';
import {
  loadMaCisCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisSortCreator,
  setMaCisProfileCreator,
  createMaCisCreator,
  setMaCisFiltersCreator,
} from '../../../../store/actionsCreators';

const mapStateToProps = ({ loading, ma, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS'),
  type: 'ma',
  list: ma.cis.reports,
  certificationBody: user.user.memberAssociation?.certificationBody?.id,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('reports')),
  setPage: (payload) => dispatch(setMaCisPageCreator('reports', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('reports', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('reports', payload)),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('reports', payload)),
  createReport: (payload, history) => dispatch(createMaCisCreator('reports', payload, history)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('reports', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificationReports);
